import { customerCare } from '../constant/constant';

// const shopCategories = [
//   'Vitamins & Supplements',
//   'Skincare & Beauty',
//   'Baby Care Essentials',
//   'Over The Counter Medicine',
// ];

const Footer = () => (
  <footer className="bg-primary-blue-500 px-5 py-10 text-white md:px-8 md:py-14">
    <div className="container-standard">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[repeat(auto-fit,minmax(220px,1fr))] lg:gap-8">
        <div>
          <img
            src={'/logo/monivea-road-logo.png'}
            alt="Monivea Road"
            className="h-auto w-auto max-w-[220px] object-contain"
          />
        </div>

        {/* <div>
          <h3 className="text-xs font-bold uppercase text-white md:text-sm">
            Shop Categories
          </h3>
          <nav className="mt-4 flex flex-col space-y-3">
            {shopCategories.map((category) => (
              <a
                key={category}
                href=""
                className="text-xs font-regular text-white/80 hover:text-white md:text-sm"
              >
                {category}
              </a>
            ))}
          </nav>
        </div> */}

        <div className="invisible">
          <h3 className="text-xs font-semibold uppercase text-white md:text-sm">
            Customer Care
          </h3>
          <nav className="mt-4 flex flex-col space-y-3">
            {customerCare.map((item) => (
              <a
                key={item.name}
                href={item.url}
                className="text-xs font-regular text-white/80 hover:text-white md:text-sm"
                target="_blank"
              >
                {item.name}
              </a>
            ))}
          </nav>
        </div>

        <div>
          <a
            href="https://monivearoad.com.au/contact-us/"
            className="inline-flex items-center justify-center rounded-lg bg-secondary-pink-500 px-6 py-2 text-xs font-semibold text-white hover:bg-secondary-pink-600 md:text-sm"
            target="_blank"
          >
            Contact Us
          </a>

          <p className="mt-4 text-xs md:text-sm">1800 123 687</p>

          <p className="mt-4 text-xs text-white/80 md:text-sm">
            Monday - Thursday
            <br />
            8:30am - 5:00pm
          </p>

          <p className="mt-4 text-xs text-white/80 md:text-sm">
            Friday
            <br />
            8:30am - 3:30pm
          </p>
        </div>
      </div>

      <div className="mt-10 border-t border-white/10 pt-6 md:mt-14">
        <p className="text-xs text-white/70">
          © 2026 Monivea Road. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
